import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { getControlNames } from '../../../common/formValidationHelper';
import { PassRestrictedCheckboxTextKey } from './pass-restricted-checkbox-texts/pass-restricted-checkbox-texts.component';

@Component({
  selector: 'app-pass-restricted-checkbox',
  templateUrl: './pass-restricted-checkbox.component.html',
  styleUrl: './pass-restricted-checkbox.component.scss'
})
export class PassRestrictedCheckboxComponent implements OnInit {

  @Input() control: AbstractControl;
  @Input() title: PassRestrictedCheckboxTextKey;
  @Input() labels: Record<string, PassRestrictedCheckboxTextKey> = {};
  @Input() required: boolean;
  @Input() selectedCheckbox$?: Subject<string> = new Subject();

  private readonly destroyRef = inject(DestroyRef);

  group: FormGroup;

  constructor(protected formBuilder: FormBuilder) {}

  ngOnInit(): void {
    const formControls = Object.fromEntries(Object.keys(this.labels).map(key => [key, [false, []]]));
    this.group = this.formBuilder.group(formControls);
    this.selectedCheckbox$.pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(value => this.onCheckboxClick(value));
  }

  get controlNames(): Array<string> {
    return getControlNames(this.group);
  }

  labelFor(name: string): PassRestrictedCheckboxTextKey {
    return this.labels[name];
  }

  onCheckboxClick(clickedCheckbox: string | null) {
    if (clickedCheckbox == null) {
      this._deselectAll()
      return;
    }

    const clickedControl = this.group.get(clickedCheckbox);

    //Once a checkbox is clicked, it cannot be unclicked
    if (!clickedControl.value) {
      clickedControl.setValue(true, {emitEvent: false});
      this.control.setValue(clickedCheckbox, {emitEvent: true});
    } else {
      clickedControl.setValue(true, {emitEvent: false});
      return;
    }

    for (const name of this.controlNames) {
      if (clickedCheckbox !== name) {
        this.group.get(name).setValue(false, {emitEvent: false});
      }
    }
  }

  private _deselectAll() {
    for (const name of this.controlNames) {
      this.group.get(name).setValue(false, {emitEvent: false});
    }
  }
}
